// External deps

import PropTypes from 'prop-types';
import { Button, Label } from 'ypf-pas-general-ui-components';
import { AiOutlineMinusCircle } from 'react-icons/ai';

// Internal deps
import './MonthlyApproversTable.scss';
import ComponentWithTooltip from '../../../../../../components/ComponentWithTooltip/ComponentWithTooltip';

const MonthlyApproversTable = ({ approvers, onDelete, canEdit, isOyM }) => (
  <div className={`monthly-approvers-table ${isOyM ? 'is-oym' : 'is-not-oym'}`}>
    <div className="monthly-approvers-table-header">
      <Label label="Aprobador" />

      {isOyM ? (
        <>
          <Label label="Ubicación" />
          <Label label="Ubicación y Contrato" />
        </>
      ) : (
        <Label label="Equipo" />
      )}
      <Label label="Servicio" />
      <Label label="Contrato" />
    </div>
    {approvers?.map((approver, index) => (
      <div
        className={`monthly-approvers-table-row ${approvers.length - 1 !== index ? 'mb-3' : ''}`}
        key={approver?.id}
      >
        <ComponentWithTooltip id="hidden-tooltip" tooltipText={approver.nombre}>
          <div className="field text-truncate">{approver.nombre}</div>
        </ComponentWithTooltip>
        {isOyM ? (
          <>
            <ComponentWithTooltip id="hidden-tooltip" tooltipText={approver.ubicacionTecnicaNombre}>
              <div className="field text-truncate">{approver.ubicacionTecnicaNombre}</div>
            </ComponentWithTooltip>
            <ComponentWithTooltip id="hidden-tooltip" tooltipText={approver.ubicacionContrato}>
              <div className="field text-truncate">{approver.ubicacionContrato}</div>
            </ComponentWithTooltip>
          </>
        ) : (
          <div className="field text-truncate">{approver.equipoNombre}</div>
        )}
        <ComponentWithTooltip id="hidden-tooltip" tooltipText={approver.servicioNombre}>
          <div className="field text-truncate">{approver.servicioNombre}</div>
        </ComponentWithTooltip>
        <div className="field text-truncate">{approver.contratoNumero}</div>

        {canEdit && (
          <Button
            className="delete-button"
            colorIcon="danger"
            disabled={!canEdit}
            icon={AiOutlineMinusCircle}
            onClick={() => onDelete(approver.id)}
            type="button"
            widthButton="40px"
          />
        )}
      </div>
    ))}
  </div>
);

export default MonthlyApproversTable;

MonthlyApproversTable.propTypes = {
  approvers: PropTypes.arrayOf(PropTypes.shape({})),
  onDelete: PropTypes.func,
  canEdit: PropTypes.bool,
  isOyM: PropTypes.bool
};

MonthlyApproversTable.defaultProps = {
  approvers: [],
  onDelete: () => {
    /* Empty */
  },
  canEdit: true,
  isOyM: false
};
